import React, { Component } from 'react'
import { ProductConsumer } from '../../context/context';
import styled from "styled-components";
import {Modal} from "react-bootstrap";




export default class DeleteGallery extends Component {
    render() {
        return (
            <>
            <ProductConsumer>
            {value=>{
               const{handleModalClose,modalOpen,nrToDelete,deleteProduct,productToDelete}=value;
                return<ModalGalleryWrapper>

      <Modal
        size="lg"
        show={modalOpen}
        onHide={handleModalClose}
        dialogClassName="modal-90w"
        aria-labelledby="example-custom-modal-styling-title"
      >
        <Modal.Header closeButton>
          <Modal.Title id="example-custom-modal-styling-title">
            Vil du slette nr {nrToDelete}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
            <div className="contaner d-flex">
                <button onClick={()=>deleteProduct(productToDelete)} className="btn btn-danger btn-lg mr-auto p2">ja</button>
                <button onClick={handleModalClose} className="btn btn-primary btn-lg p-2">Nej</button>
            </div>
        </Modal.Body>
      </Modal>
						
						
						
				
                </ModalGalleryWrapper>
            }}
            </ProductConsumer>
            </>
        )
    }
}
const ModalGalleryWrapper = styled.div`
.modal-backdrop.show {
    opacity: 0.8;
}
`;